// PATCH /api/v1/talent_surveys/:id/applicant/:applicant_id
import {generateFetchOptions} from '../../index';

export async function attribute(talentSurveyId: string, applicantId: string): Promise<Response> {
  return fetch(
    `${process.env.REACT_APP_API_HOST}/api/v1/talent_surveys/${talentSurveyId}/applicant/${applicantId}`,
    generateFetchOptions({method: 'PATCH', isProtected: false})
  );
}
